import { Heading, Text, Img } from "../../components";
import LandingPageWIPContent from "../../components/LandingPageWIPContent";
import React, { Suspense } from "react";

const data = [
  {
    image: "images/img_favorite.svg",
    title: "You don’t need to be a storyteller",
    description:
      "Bringing stories to life isn’t easy, but it doesn’t have to be. You don’t need to be a writer or an illustrator to turn your memories into something special. We make it effortless.",
  },
  {
    image: "images/img_checkmark.svg",
    title: "From instant to timeless",
    description:
      "Photos capture seconds. A Lifetoon comic turns them into stories that last forever. Keep your most cherished moments alive in a way that words and pictures alone never could.",
  },
  {
    image: "images/img_frame_14450_deep_purple_50_01.svg",
    title: "A gift like no other",
    description:
      "Whether for a loved one or yourself, this isn’t just another generic present. It’s personal, heartfelt, and impossible to forget.",
  },
];

export default function LandingpagewipStackwhylifetoo() {
  return (
    <div className="relative h-[fit-content] mt-[17vw] px-[3vw] md:px-5 sm:mt-[-100px] sm:h-auto">
      <div className="mx-auto flex flex-1 flex-col items-center gap-12 px-14 md:px-5">
        <div className="h-[fit-content] sm:mt-[70px] md:w-[fir-content] absolute right-[15vw] top-[-12vw] flex items-center justify-center md:top-[-24vw] md:right-[0px] sm:relative m-auto flex h-[20vw] items-start justify-center sm:top-[0px] sm:mt-[40px] sm:w-full sm:h-auto sm:py-7 sm:padding-[0px]">
          <Img
            src="/images/cloud-3.svg"  // Înlocuit cu componenta <Img>
            alt="Framed Proposal"
            className="absolute z-10 w-[20vw] md:w-[fit-content] md:h-auto sm:p-0" 
          />
          <Heading
            size="text2xl"
            as="p"
            className="mb-[10%] z-20 text-center !font-grandstander p-10 sm:text-[16px] text-[1.2vw] md:text-[20px] font-normal uppercase `md:text-[12px]"
            style={{ marginTop: '32px' }}
          >
            <span className="block">I never imagined my</span>
            <span className="block">proposal story could </span>
            <span className="block">look like a real comic</span>
            <span className="block font-bold">book. It’s now framed in </span>
            <span>our home! ✨</span>
          </Heading>
        </div>
    
        <div className="flex flex-col items-center">
          <Heading size="headingmd" as="h1" className="text-[2.5vw] font-bold md:text-[44px] sm:text-[38px]">
            Why Lifetoon?{" "}
          </Heading>
          <Text as="p" className="text-[1vw] md:text-[20px] font-normal italic sm:text-center">
            Because some stories deserve more than just a memory.
          </Text>
        </div>
        <div className="flex w-[50vw] flex-col gap-[1.2vw] sm:gap-[24px] md:w-full">
          <Suspense fallback={<div>Loading feed...</div>}>
            {data.map((d, index) => (
              <LandingPageWIPContent {...d} key={"listtitle" + index} />
            ))}
          </Suspense>
        </div>
      </div>
    </div>
  );
}
